import utils from '../others/utils.js';

const emptyUser =
  {
    email: '',
    screenname: '',
    password: '',
    access_token: '',
    db: '',
    roles: [],
    telcode: null,
  };
let user;
try {
  user = localStorage.getItem('user') ? JSON.parse(localStorage.getItem('user')) : emptyUser;
} catch (err) {
  user = emptyUser;
  localStorage.setItem('user', JSON.stringify(emptyUser));
  utils.deleteCookie('mtech_token');
}

export default {
  refreshing: false, // refreshing user
  active: -1, // active item
  next: null, // next item
  prev: null, // previous item
  total: 0, // total items
  rightVisible: false,
  settings: {
    defaultCity: '',
    users: [],
  },
  searchQuery: {
    term: '',
    where: '',
  },
  searchResults: {
    results: [],
    term: '',
  },
  requests: [],
  user,
  errors: [],
  units: {},
  offMedias: {},
  parents: {},
  cases: {},
  syncer: null,
  initializing: true,
  syncing: '',
  buffer: null,
  pageHeight: 0,
  socket: {
    isConnected: false,
    message: '',
    reconnectError: false,
  },
};



// WEBPACK FOOTER //
// ./src/store/state.js